/** Talent community domain storage (talents + groups listings). All per-tab (sessionStorage): search state and arrow-navigation batch/paging. */
import Storage from '../index';
import StorageKeys from '../keys';

const talentCommunity = {
    getTalentsSearchState: (lang) => Storage.get(StorageKeys.talentsSearchState(lang), null),
    setTalentsSearchState: (lang, state) => Storage.set(StorageKeys.talentsSearchState(lang), state),

    getTalentsBatch: () => Storage.get(StorageKeys.talentsInTcBatch, null),
    setTalentsBatch: (hashes) => Storage.set(StorageKeys.talentsInTcBatch, hashes),

    getTalentsPaging: () => Storage.get(StorageKeys.talentsInTcPaging, null),
    setTalentsPaging: (paging) => Storage.set(StorageKeys.talentsInTcPaging, paging),

    getGroupsSearchState: (lang) => Storage.get(StorageKeys.tcGroupsSearchState(lang), null),
    setGroupsSearchState: (lang, state) => Storage.set(StorageKeys.tcGroupsSearchState(lang), state),
    removeGroupsSearchState: (lang) => Storage.remove(StorageKeys.tcGroupsSearchState(lang)),

    getGroupsBatch: () => Storage.get(StorageKeys.tcGroupsBatch, null),
    setGroupsBatch: (hashes) => Storage.set(StorageKeys.tcGroupsBatch, hashes),

    getGroupsPaging: () => Storage.get(StorageKeys.tcGroupsPaging, null),
    setGroupsPaging: (paging) => Storage.set(StorageKeys.tcGroupsPaging, paging),
};

export default talentCommunity;
